import { PropsSkeletonBlock } from './PropsSkeletBlcok';
import classNames from 'classnames';

import styles from './Skelet.module.scss';

export const SkeletonBLock = ({
  width,
  height,
  className,
  skeletonActive,
  skeletonActive2,
  skeletonActive3,
  skeletonActive4,
}: PropsSkeletonBlock): JSX.Element => {
  return (
    <div
      style={{ width, height }}
      className={classNames(
        styles.skeleton,
        skeletonActive && styles.skeleton,
        skeletonActive2 && styles.skeleton2,
        skeletonActive3 && styles.skeleton3,
        skeletonActive4 && styles.skeleton4,
        className,
      )}
    />
  );
};
